import {FC, useEffect, useState} from 'react';
import {Formik} from 'formik';

import {Use} from 'core/_types/selectOptionsTypes/UsesType';

import UsesForm from './UsesForm';

type UsesProps = {
  uses: Array<Use>;
};

export const Uses: FC<UsesProps> = ({uses}) => {
  const [totalUses, setTotalUses] = useState('');

  useEffect(() => {
    if (uses.length) {
      const dollarUSLocale = Intl.NumberFormat('en-US');
      setTotalUses(dollarUSLocale.format(uses.reduce((acc, use) => acc + +use.principal.split(' ')[1], 0)));
    }
  }, [uses]);

  const initialValues: UsesProps = {
    uses,
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values) => {
        // eslint-disable-next-line no-alert
        alert(JSON.stringify(values));
      }}
    >
      {(props) => (
        <UsesForm
          values={props.values}
          handleChange={props.handleChange}
          setFieldValue={props.setFieldValue}
          initialValues={initialValues}
          totalUses={totalUses}
        />
      )}
    </Formik>
  );
};
